import { type KioskDisplayBasketItem } from "./types";

/**
 * Allowance saving on one basket line (incl VAT). The two allowance types land
 * in different engine fields: unitPrice → the capped `allowanceDeductionInclVat`;
 * numberOfProducts → the per-line discount delta (`unitTotalListPriceInclVat − unitTotalPriceInclVat`).
 */
export function getLineAllowanceDeductionInclVat(
  item: KioskDisplayBasketItem
): number {
  if (item.appliedAllowanceType === "unitPrice") {
    return item.allowanceDeductionInclVat;
  }

  if (
    item.appliedAllowanceType === "numberOfProducts" &&
    item.unitTotalListPriceInclVat !== null
  ) {
    return item.unitTotalListPriceInclVat - item.unitTotalPriceInclVat;
  }

  return 0;
}
